__turbopack_context__.v({
  "infoMenu": "EnergyUsageTopNav-module__rDe3YG__infoMenu",
  "mobileSecondRow": "EnergyUsageTopNav-module__rDe3YG__mobileSecondRow",
  "nav": "EnergyUsageTopNav-module__rDe3YG__nav",
  "rightEnd": "EnergyUsageTopNav-module__rDe3YG__rightEnd",
});
